import { __cAccountService } from '@/services/client/__c.account.service'
import { useQuery } from '@tanstack/react-query'

export function useVoucherWalletQuery(
  params?: { device_token: string },
  enabled?: boolean
) {
  return useQuery({
    queryKey: ['query.voucher-wallet', params],
    queryFn: async () => {
      const response = await __cAccountService.getVoucherWallet(params)
      return response.data
    },
    enabled,
  })
}
